import CircleAudit from './src/main';

/* istanbul ignore next */
CircleAudit.install = function(Vue) {
  Vue.component(CircleAudit.name, CircleAudit);
};

export default CircleAudit;
